import * as init from '../../src/application/actions/user.js';

import {
  clientlist,
  clientdetail,
  clientcontacts,
  loginasclient,
  getSelfCliente
} from '../../src/application/actions/agents.js';

import {
  invoiceList,
  paymentList,
  invoiceDownload,
  invoicePreview
} from '../../src/application/actions/invoices.js';
import {
  ddtList
} from '../../src/application/actions/ddt.js';

import * as orders from './actions/orders.js';

import {
  portafoglioreclami,
  nuovoReclamoSend,
  nuovoReclamoAddPictures,
  nuovoReclamoRemovePictures,
  nuovoReclamoUpdate,
  nuovoReclamoInit
} from '../../src/application/actions/reclami.js';

import {
  twebredirect
} from '../../src/application/actions/tweb.js';

import {
  mailModalOpen,
  orderEmailSend,
  clientEmailSend,
  invoiceEmailSend,
  sendCorrespondentMail
} from '../../src/application/actions/email.js';

import * as reports from './actions/reports';
import * as eldom from './actions/eldom';

const actions = {
  ...init,
  clientlist,
  clientdetail,
  clientcontacts,
  loginasclient,
  mailModalOpen,
  orderEmailSend,
  clientEmailSend,
  invoiceEmailSend,
  invoiceDownload,
  invoicePreview,
  invoiceList,
  paymentList,
  ddtList,
  portafoglioreclami,
  nuovoReclamoSend,
  nuovoReclamoAddPictures,
  nuovoReclamoRemovePictures,
  nuovoReclamoUpdate,
  nuovoReclamoInit,
  twebredirect,
  getSelfCliente,
  ...orders,
  ...reports,
  ...eldom
}


export default actions;